export default __webpack_public_path__ + "static/media/Poppins-Regular.e5916eb4.woff2";